module.exports = __webpack_public_path__ + "img/ended.987fd58f.png";